module.exports = {
  condition: 'condition',
  display: 'display',
  hide: 'hide',
  refresh: 'Refresh',
  have: 'Have',
  none: 'None',
  closure: 'Close',
  import: 'Import',
  export: 'Export',
  confirm: 'Confirm',
  cancel: 'Cancel',
  search: 'Search',
  select: 'Select',
  prompt: 'Prompt',
  returnIndex: 'Return Front Page',
  returnLastPage: 'Go back Last Page',
  clearSearchOption: 'Clear Option',
  operate: 'Operate',
  operatedSuccess: 'Successful operation!',
  batchOperateSuccess: "Batch operation succeeded!",
  requestedFail: 'Request failed!',
  operatedFail: 'Operation Failed,Please Try Again!',
  cancelOperate: 'User canceled operation!',
  zhong: 'Chinese',
  ying: 'English',
  jian: 'Khmer',
  submit: 'Submit',
  required: 'Please fill in the required parameters',
  edit: 'Edit',
  batchDelete: 'Batch Delete',
  delete: 'Delete',
  add: 'Add',
  top: 'Top',
  selection_required: "Select at least one field",
  enter_num_between: "Please input number between {arg0} and {arg1}",
  return: 'Return',
  upload_file: "Upload File",
  upload_img: "Upload Photo",
  deleteVideo: "Delete Video",
  upload_type_img: "Support to upload {type} type file, each within {size}",
  invalid_file_type: "File format failed",
  upload_fail: "Upload Failed",
  file_format_fail: 'File Format Error',
  noData: 'No Data',
  invalid_phone: 'Please input legal phone number',
  loading_map: 'Loading',
  map_load_failed: 'The map failed to load, please refresh and try again',
  preview: "Preview",
  size: "Size",
  copy: 'Copy',
  copySuccess: 'Copy Successfully!',
  semicolon: '：',
  tipsSwitch: 'If there are multiple pictures, you can switch!',
  lastWeek: 'Last Week',
  lastMonth: 'Last Month',
  lastTreeMonth: 'Last Three Month',
  lastTwoMonth: 'Last Two Month',
  today: 'Today',
  nextThreeDays: 'Next 3 days',
  nextWeek: 'Next week',
  nextMonth: 'Next month',
  nextStep: 'Next Step',
  network_error: "Network error",
  simplified: 'Simplified Chinese',
  numberLetterRequired: '只能输入英文、数字组合'
}
